import './tech-stack.css';


const TECH = [
    // Languages
    { name: 'Python',      icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg',         group: 'Languages' },
    { name: 'Java',        icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg',             group: 'Languages' },
    { name: 'JavaScript',  icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg', group: 'Languages' },
    { name: 'TypeScript',  icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg', group: 'Languages' },
    { name: 'C',           icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-original.svg',                   group: 'Languages' },
    { name: 'GDScript',    icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/godot/godot-original.svg',           group: 'Languages' },

    // Frameworks & Libraries
    { name: 'React',       icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg',           group: 'Frameworks' },
    { name: 'PyTorch',     icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pytorch/pytorch-original.svg',       group: 'Frameworks' },
    { name: 'Flask',       icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flask/flask-original.svg',           group: 'Frameworks' },
    { name: 'Node.js',     icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg',         group: 'Frameworks' },

    // Tools & Platforms
    { name: 'Docker',      icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg',         group: 'Tools' },
    { name: 'Git',         icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg',               group: 'Tools' },
    { name: 'MongoDB',     icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg',       group: 'Tools' },
    { name: 'SQLite',      icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sqlite/sqlite-original.svg',         group: 'Tools' },
    { name: 'Godot',       icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/godot/godot-original.svg',           group: 'Tools' },
    { name: 'Linux',       icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linux/linux-original.svg',           group: 'Tools' },
];

const GROUPS = ['Languages', 'Frameworks', 'Tools'];

function TechStack() {
    return (
        <section className="about-section">
            <p className="section-eyebrow">What I work with</p>
            <h2 className="section-title">Tech stack</h2>

            <div className="tech-groups">
                {GROUPS.map(group => (
                    <div className="tech-group" key={group}>
                        <p className="tech-group-label">{group}</p>
                        <div className="tech-icon-grid">
                            {TECH.filter(t => t.group === group).map(t => (
                                <div className="tech-icon-item" key={t.name}>
                                    <img
                                        src={t.icon}
                                        alt={t.name}
                                        className="tech-icon-img"
                                        loading="lazy"
                                        onError={e => { e.currentTarget.style.opacity = '0.3'; }}
                                    />
                                    <span className="tech-icon-label">{t.name}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default TechStack;